"use strict";

exports.FIELD_LABEL = 'Fields::Label';
exports.FIELD_URL = 'Fields::Url';
exports.FIELD_CHECKBOX = 'Fields::Checkbox';
exports.FIELD_IMAGE_LABEL = 'Fields::ImageLabel';
exports.FIELD_MAP = 'Fields::Map';
exports.FIELD_SWITCH = 'Fields::Switch';
exports.FIELD_SELECT = 'Fields::Select';
exports.FIELD_IMAGE_RADIO = 'Fields::ImageRadio';
exports.FIELD_CUIT = 'Fields::Cuit';
exports.FIELD_CHIP = 'Fields::Chip';
exports.FIELD_DATE = 'Fields::Date';
exports.FIELD_PHONE = 'Fields::Phone';
exports.FIELD_TEXT_AREA = 'Fields::TextArea';
exports.FIELD_IMAGE = 'Fields::Image';
exports.FIELD_CAPTCHA = 'Fields::Captcha';
exports.FIELD_TEXT = 'Fields::Text';
exports.FIELD_EMAIL = 'Fields::Email';
exports.FIELD_RADIO = 'Fields::Radio';
exports.FIELD_FORM_LINK = 'Fields::FormLink';
exports.FIELD_CREDIT_CARD = 'Fields::CreditCard';
exports.FIELD_ANIMATED_CREDIT_CARD = 'Fields::AnimatedCreditCard';
exports.FIELD_PASSWORD = 'Fields::Password';
exports.FIELD_PDF = 'Fields::Pdf';
exports.FIELD_CHECKLIST = 'Fields::Checklist';
exports.FIELD_RATING_STAR = 'Fields::Rating';
exports.FIELD_ATTACHMENT = 'Fields::Attachment';
exports.FIELD_SKETCH = 'Fields::Sketch';
exports.FIELD_AUTOCOMPLETE = 'Fields::SelectCustom';
exports.FIELD_TABLE = 'Fields::Table';